import { ActionTypeKeys } from 'embed/actions'
import { configResultsUuidSelector } from 'embed/selectors/config'
import { uiSelectedStepSelector, uiStateSelector } from 'embed/selectors/ui'

import { datadogRum, RUMContextKeys } from '../RUM'
import { RUMTimingEvents } from '../RUM/constants'

const datadogMiddleware = (store) => {
  let prevResultsUuid
  return (next) => (action) => {
    try {
      switch (action.type) {
        case ActionTypeKeys.STEP_FUNCTIONAL:
          // after all middleware and store reduced, step functional will be true
          // this makes sure we only fire the DataDog event once
          if (uiStateSelector(store.getState()).stepFunctional === false) {
            datadogRum.addTiming(RUMTimingEvents.EMBED_STEP_FUNCTIONAL)
          }
          break
        default:
      }
    } catch (err) {
      console.error('DATADOG MIDDLEWARE ERROR BEFORE NEXT', err)
    }

    const result = next(action)
    const currentState = store.getState()

    try {
      switch (action.type) {
        case ActionTypeKeys.STEP_SELECTED:
          datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_APPLICATION_STEP, action.step)
          datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_APPLICATION_PRODUCT, action.product)
          break
        case ActionTypeKeys.PRODUCT_SELECTED:
          datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_APPLICATION_PRODUCT, action.product)
          datadogRum.addRumGlobalContext(
            RUMContextKeys.DD_CTX_APPLICATION_STEP,
            uiSelectedStepSelector(currentState)[action.product],
          )
          break
        default:
      }
      const resultsUuid = configResultsUuidSelector(currentState)
      if (resultsUuid !== prevResultsUuid) {
        prevResultsUuid = resultsUuid
        datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_RESULTS_UUID, resultsUuid)
      }
    } catch (err) {
      console.error('DATADOG MIDDLEWARE ERROR AFTER NEXT', err)
    }

    return result
  }
}

export default datadogMiddleware
